import {SvgIcon} from '@material-ui/core';
import React from 'react';

export default function PatientIcon(props) {
    return (
        <SvgIcon width="80" height="80" viewBox="0 0 80 80" {...props} >
            <g fill="#7B8A9D" fillRule="evenodd">
                <path fillRule="nonzero" d="M38.354 0c8.174 0 14.79 6.398 14.79 14.287 0 1.484-.232 2.908-.665 4.247.892 0 2.466.79 3.254 1.367 1.359.995 2.375 2.323 3.202 3.718.973 1.876 1.606 3.849 1.606 5.869 0 6.061-4.866 11.112-11.094 11.545v.048H44.33c-1.324-5.039-5.894-8.619-11.185-8.619h-5.75c-5.29 0-9.861 3.58-11.185 8.62h-3.303v-.049c-.29.048-.582.048-.873.048C5.434 41.081 0 35.928 0 29.583c0-3.006 1.262-5.869 3.397-7.968C3.605 21.41 5.41 19.9 5.41 19.9c-.194-.818-.435-2.15-.435-3.016 0-6.398 5.4-11.594 12.067-11.594 2.76 0 5.475.979 7.67 2.68l.26.207C27.357 3.319 32.418 0 38.353 0zM30.27 12.264c-5.284 0-9.568 4.284-9.568 9.568 0 5.283 4.284 9.567 9.568 9.567s9.567-4.284 9.567-9.567c0-5.284-4.283-9.568-9.567-9.568z" transform="translate(9.73 15.135)" />
                <g>
                    <path d="M3.98.44c1.828 0 3.31 1.482 3.31 3.31v4.257H.67V3.75C.669 1.922 2.15.44 3.979.44z" transform="translate(9.73 15.135) rotate(-46 58.047 -6.025)" />
                    <path fillRule="nonzero" d="M3.98 16.444c-1.829 0-3.311-1.482-3.311-3.31V8.875H7.29v4.257c0 1.829-1.483 3.31-3.311 3.31z" opacity=".263" transform="translate(9.73 15.135) rotate(-46 58.047 -6.025)" />
                </g>
                <path fillRule="nonzero" d="M32.345 25.126c.213-.287.62-.347.907-.133.288.214.347.62.133.908-.766 1.03-1.824 1.558-3.115 1.558-1.29 0-2.348-.529-3.115-1.558-.214-.288-.154-.694.133-.908.288-.214.694-.154.908.133.521.7 1.193 1.036 2.074 1.036.882 0 1.554-.336 2.075-1.036z" transform="translate(9.73 15.135)" />
            </g>
        </SvgIcon>

    )
}



// WEBPACK FOOTER //
// ./src/components/controls/icons/PatientIcon.jsx